import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
export default function EmailPreviewButton({ onClick }) {
    return (_jsxs("button", { className: "btn btn-primary", onClick: onClick, type: "button", children: [_jsx("span", { "aria-hidden": "true", className: "far fa-eye mr-1" }), "Preview Email"] }));
}
